var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup321(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 32,
    cy: 32,
    r: 31.5,
    fill: "#E69A8D",
    stroke: "#E69A8D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 21H19C18.4469 21 18 21.4469 18 22V42C18 42.5531 18.4469 43 19 43H45C45.5531 43 46 42.5531 46 42V22C46 21.4469 45.5531 21 45 21ZM42.475 24.4031L32.6156 32.075C32.3719 32.2656 32.0312 32.2656 31.7875 32.075L21.925 24.4031C21.8878 24.3744 21.8606 24.3348 21.847 24.2899C21.8335 24.2449 21.8344 24.1968 21.8495 24.1524C21.8647 24.1079 21.8934 24.0693 21.9316 24.042C21.9698 24.0147 22.0155 24 22.0625 24H42.3375C42.3845 24 42.4303 24.0147 42.4684 24.042C42.5066 24.0693 42.5353 24.1079 42.5505 24.1524C42.5656 24.1968 42.5665 24.2449 42.553 24.2899C42.5394 24.3348 42.5122 24.3744 42.475 24.4031Z",
    fill: "#7A51AE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup321);
export default __webpack_public_path__ + "static/media/Group321.eb710b07af39009cdc31c0854696d5b9.svg";
export { ForwardRef as ReactComponent };